import React, { useState, useRef, useEffect } from 'react';
import { string, oneOf, func } from 'prop-types';
import { PRODUCT_ADD_ON_IDENTIFIER } from '@thd-olt-functional/utils';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';
import { ICONS } from '../../../utils/product-add-on-constants';
import { ProtectionPlanTooltip } from './ProtectionPlanTooltip';

const { HDPP } = PRODUCT_ADD_ON_IDENTIFIER;

export const HomeDepotProtectionPlan = ({
  itemId,
  channel,
  term,
  price,
  onChange,
}) => {

  const [isHdppSelected, setIsHdppSelected] = useState(false);
  const [isDualPathSelected, setIsDualPathSelected] = useState(null);
  const tooltipButtonRef = useRef(null);

  const iconUrl = ICONS.hdpp;
  const subHeading = 'Select a Home Depot Protection Plan by Allstate for:';
  /** Props for checkbox component */
  const userOptions = [{
    id: itemId,
    value: 'hdpp-accept',
    label: `${term} Year / `,
    price,
    checked: isHdppSelected,
  },
  {
    value: 'hdpp-decline',
    label: 'No thanks',
    checked: !isHdppSelected
  }];

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.on('dual-path.change', ({ output } = {}) => {
      setIsDualPathSelected(output?.isOptedIn);
    });
  }, []);

  const handleChange = (evt) => {
    const userSelectedHdpp = evt.target.value === 'hdpp-accept';
    let checked = userSelectedHdpp && !isHdppSelected;
    onChange({
      itemId,
      checked,
      addOnType: HDPP
    });
    LIFE_CYCLE_EVENT_BUS.trigger('hdpp.change', { isOptedIn: checked, itemId });
    setIsHdppSelected(checked);

  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy) tippy.hide();
  }, [isHdppSelected]);

  const tooltip = (
    <ProtectionPlanTooltip
      channel={channel}
      ref={tooltipButtonRef}
    />
  );

  if (isDualPathSelected) {
    return null;
  }

  return (
    <ProductAddOnsPod
      heading="Protect This Item"
      subHeading={subHeading}
      tooltip={tooltip}
      userOptions={userOptions}
      icon={iconUrl}
      iconHeight={47}
      iconWidth={34}
      onChange={handleChange}
      channel={channel}
      radio
    />
  );
};

HomeDepotProtectionPlan.displayName = 'ProductAddOns-HomeDepotProtectionPlan';

HomeDepotProtectionPlan.propTypes = {
  /** Device Type: Mobile or Desktop */
  channel: oneOf(['desktop', 'mobile']),
  /** protection plan price */
  price: string.isRequired,
  /** protection plan term length */
  term: string,
  /** handler for select or unselect hdpp */
  onChange: func.isRequired,
  /** protection plan item id */
  itemId: string.isRequired,
};

HomeDepotProtectionPlan.defaultProps = {
  channel: 'desktop',
  term: '',
};